import { CapacityTestStatusIcon } from './capacity-test-status-icon';

export function CapacityTestLegend() {
  return (
    <div className="mt-4 flex justify-between space-x-4">
      <div className="flex items-center gap-2">
        <CapacityTestStatusIcon statusColor="green" />
        <span className="text-xs">Passed</span>
      </div>
      <div className="flex items-center gap-2">
        <CapacityTestStatusIcon statusColor="yellow" />
        <span className="text-xs">Pending</span>
      </div>
      <div className="flex items-center gap-2">
        <CapacityTestStatusIcon statusColor="red" />
        <span className="text-xs">Failed</span>
      </div>
    </div>
  );
}
